module.exports = __webpack_public_path__ + "c39e9019349f25ae55c44424f8cb96c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss12.jpg
// module id = 718
// module chunks = 0